import { useAppContext } from "@root/global/context";
import {
  ProgressStateAdm,
  ProgressStateDtg,
  ProgressStateGbd,
  ProgressStateVda,
} from "@root/misc/constants";
import React from "react";
import { useSearchParams } from "react-router-dom";

type GameType = "gbd" | "adm" | "dtg" | "vda" | "home" | "introduction";

/** Reads ?step=<State> from the URL once on mount and jumps the page to that
 *  progress state. Should be called once in `Layout` and never be run during production.
 */
export function useDeepLinkStep(type: GameType): void {
  const ctx = useAppContext();
  const [searchParams] = useSearchParams();

  React.useEffect(() => {
    if (type === "home" || type === "introduction") return;

    const step = searchParams.get("step");
    if (step === null) return;

    const dispatch = {
      gbd: { states: ProgressStateGbd, set: ctx.setProgressStateGbd },
      adm: { states: ProgressStateAdm, set: ctx.setProgressStateAdm },
      dtg: { states: ProgressStateDtg, set: ctx.setProgressStateDtg },
      vda: { states: ProgressStateVda, set: ctx.setProgressStateVda },
    }[type];

    if (Object.values(dispatch.states).includes(step as never)) {
      dispatch.set(step as never);
    }
  }, []);
}
